export default {
  api: {
    baseUrl: 'http://localhost:7100',
    chatUrl: 'http://localhost:7002',
    leadsUrl: 'http://localhost:7018',
    vCallUrl: 'http://localhost:7019',
  },
};
